import { createState } from 'shared'
import { type Plan } from 'core'
import { computed } from '@preact/signals'

import { application } from '../application'

const defaultState: Plan[] = []

const plans = createState<Plan[]>(defaultState)

export const getPlans = async () => {
	const { data, error } = await application.value
		.forManagingEntitlements()
		.getPlans()

	if (error) return plans.updateState(() => defaultState)

	return plans.updateState(() => data!)
}

export const resetPlans = () => plans.updateState(() => defaultState)

export const plansState = plans.state
export const freePlanId = computed(
	() => plans.state.value.find(plan => plan.type === 'free')?.id || ''
)
